import type { TBlueTable } from "@app/types/insider";
export type TAppJob = {
  ord: number;
  shid0: string;
  shid1: string;
  _hkey: string;
  _hvalue: string;
  apiUrl: string;
  active: boolean;
  label?: string;
  expectedShardCount?: number;
  storeHKey: string;
  storeHValue: string;
  storeShardCount: number;
};

export const idb_appJobs = {
  name: "appJobs",
  primaryKey: "ord",
  idb_indexes: [
    { name: "byHash", keyPath: ["_hkey", "_hvalue"] },
    { name: "shid0", keyPath: "shid0" },
    { name: "shid1", keyPath: "shid1" },
  ],
};

export const appJobs: TBlueTable<TAppJob> = {
  ...idb_appJobs,

  empty: {
    ord: -1,
    shid0: null,
    shid1: null,
    _hkey: null,
    _hvalue: null,
    apiUrl: null,
    active: false,
  } as TAppJob,

  initialState: {},
  apiUrl: null,
  urlPathBuilder: null,
  mapWrite: null,
  mapRead: null,
  bootPriority: 0,
  starfx: true,
  starfx_index: "ord",
  idb: true,
  onmru: "no",
  oncsdb: "no",
  label: "App Jobs",
  appContext: [],
};
